import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiEditContact = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'updateContactDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.put(serviceURL, {
    id: payload.contactId,
    ...payload.data,
  });
};
export const apiGetContactDetail = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getContactDetailsByIdDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      contactId: payload.contactId,
    },
  });
  return axios.get(serviceURL);
};
